<template>
  <HXContentCard title="Lista de Centros de Operacion">
    <div class="text-right px-4 mt-4">
      <div class="d-flex justify-content-end">
        <vs-button animation-type="vertical" class="mx-1" @click="$router.push('CentrosDeOperacion_Agregar')">
          <i class="fas fa-plus-circle pr-1"></i>
          Agregar Centro de Operacion
          <template #animate>
            <i class="fas fa-plus-circle"></i>
          </template>
        </vs-button>
      </div>
    </div>
    <div class="table-responsive px-4 mt-3">
      <table id="datatable_CentrosDeOperacion"
        class="table table-bordered table-responsive-md table-striped text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Area</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in listaItems" :key="item.id">
            <td>
              <strong>
                {{ index + 1 }}
              </strong>
            </td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.area.descripcion }}</td>
            <td>{{ item.estado == 1 ? "Activo" : "Inactivo" }}</td>
            <!-- <span class="pointer">
                      <i @click="$router.push('Sucursales_editar/'+item.id)" class="fas fa-solid fa-pen px-1 text-success"></i>
                      <i @click="deleteRow(item.id)"  class="fas fa-solid fa-trash px-1 text-danger"></i>
                      </span> -->
            <td style="width: 150px !important">
              <ButtonGroup :Id="item.id" :data="dataIcons"></ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </HXContentCard>
</template>
<script>
import { core } from "../../../config/pluginInit";
import ButtonGroup from "../../../components/ButtonGroup/ButtonGroup.vue";
const Swal = require("sweetalert2");

export default {
  components: {
    ButtonGroup,
  },
  name: "DataTable",
  data() {
    return {
      isCreating: false,
      listaItems: [],
      logoEmpresa: "",
      usuario: {},
      dataIcons: [
        {
          type: "success",
          tooltip: "Editar Centro de Operacion",
          title: "",
          value: () => 10,
          iconName: "pen",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: (Id) => {
            console.log("Activated");
            this.$router.push("CentrosDeOperacion_Editar/" + Id);
          },
          onDeactivate: () => {
            console.log("Deactivate");
          },
        },
        {
          type: "danger",
          tooltip: "Eliminar registro",
          title: "",
          value: () => 0,
          iconName: "trash",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: (Id) => {
            console.log("Activated");
            this.deleteRow(Id);
          },
          onDeactivate: () => {
            console.log("Deactivate");
          },
        },
      ],
    };
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      core.index();
      await this.getData();
      window.$("#datatable_CentrosDeOperacion").DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
      });
      this.$isLoading(false);
    } catch (error) {
      this.$isLoading(false);
      console.log("error", error);
    }
  },
  methods: {
    async deleteRow(id) {
      Swal.fire({
        title: "Seguro eliminar registro?",
        text: "Después de eliminarlo no podrás recuperarlo!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //let loader = this.$loading.show();
          await this.$store.dispatch("hl_get", {
            path: "Marca/delete/" + id,
          });

          //console.log("res", res);
          //loader.hide()
          await this.getData();

          Swal.fire("Listo!", "Registro eliminado correctamente.", "success");
        }
      });
    },

    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "CentroOperacion/GetByEmpresa/" + this.usuario.empresa.id,
        });
        console.log("res", res); // Muestra todo el objeto

        // Ahora accedemos a res.data que es el arreglo con los items
        if (res.data && res.data.length > 0) {
          this.listaItems = res.data;
        } else {
          this.listaItems = [];
        }
      } catch (error) {
        this.listaItems = [];
        console.log("err", error);
      }
    },

  },
};
</script>
